import { MouseMoveWrapper } from './zoom.styled'
import { mediaUrl } from '@bluheadless/ui-logic/src/assets'
import Image from '../../particles/image'
import { string, func } from 'prop-types'
import { useConfig } from '@bluheadless/ui-logic/src/providers/config'

const MouseMoveZoom = ({ alt = '', className, image, setToggleZoom, ...props }) => {
	const {
		catalog: {
			products: {
				images: { width: originalWidth, height: originalHeight },
			},
		},
	} = useConfig()

	const mouseMoveHandler = (e) => {
		const image = e.target
		if (image) {
			const imageHeight = image.height
			const windowHeight = window.innerHeight
			const scrollY = -((imageHeight - windowHeight) / windowHeight) * (e.pageY - window.pageYOffset)
			image.style.transform = `translate3d(0px, ` + scrollY + `px, 0px)`
		}
	}

	return (
		<MouseMoveWrapper
			className={className}
			onMouseMove={(e) => mouseMoveHandler(e)}
			onClick={() => setToggleZoom({ open: false, currentImage: image })}
			{...props}
		>
			<Image
				src={mediaUrl(image)}
				alt={alt}
				unoptimized
				originalWidth={originalWidth}
				originalHeight={originalHeight}
			/>
		</MouseMoveWrapper>
	)
}

MouseMoveZoom.propTypes = {
	image: string.isRequired,
	setToggleZoom: func.isRequired,
	alt: string,
}

export default MouseMoveZoom
